import $ from 'jquery';
import Handlebars from 'handlebars';
import PageCache from 'lib/page-cache';
import ucFirst from 'lib/ucFirst';
import disclaimers from 'components/disclaimers';
import blocks from 'lib/analytics/blocks/index';
import langFromUrl from 'lib/util/langFromUrl';
import lscs from 'lib/services/lscs';
import Slicker from 'components/slicker';
import Navigation from './navigation';
import txtLoader from './vehicles-loader.part.hbs';
import txtCarousel from './vehicles-carousel.part.hbs';
import txtContainer from './vehicles-container.part.hbs';
import txtSeries from './vehicles-series.part.hbs';
import callouts from './navigation.vehicles.callout';
import 'lazyload';
import 'lib/loader/series';
import 'lib/transforms/series.byCategory.merged.hybrids';
import 'lib/transforms/series.byCategory';
import 'lib/transforms/series.latest';
import 'lib/helpers/concat';
import 'lib/helpers/disclaimerMpg';
import 'lib/helpers/disclaimer';
import 'lib/helpers/data-attr';
import 'lib/helpers/monetize';
import 'lib/loader/vehicleAssociation';
// This is a plugin for the navigation to handle the vehicles menu

var CarouselMode = 'carousel';
var ContainerMode = 'container';

var __tmplLoader = Handlebars.compile(txtLoader);
var __tmplCarousel = Handlebars.compile(txtCarousel);
var __tmplContainer = Handlebars.compile(txtContainer);

var __lang = langFromUrl();
var __vehicleNavCalloutsDcr = 'templatedata/BAT/VehicleNavCallouts/data/VehicleNavCallouts';

// Series display names seem to include markdown of some nature
var __italicsRegex = /_(.*?)_/g;
function __formatDisplayName(name) {
  var displayName = name.replace(__italicsRegex, function (match, p1) {
    return '<i>' + p1 + '</i>';
  });
  return ucFirst(displayName);
}

var __compareList = [];

function __checkHasCompare(series_code) {
  if (__compareList.length > 0) {
    for (var i = 0; i < __compareList.length; i++) {
      var vehicleCode = __compareList[i][0];
      var seriesCode = vehicleCode.substring(5);
      if (seriesCode === series_code) {
        return true;
      }
    }
  }

  return false;
}

function __convertObjToList(obj) {
  var result = Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });

  return result;
}

var callOut = [];

function __parseVehicleNavCalloutsDcr(xmlData) {
  var $data = $(xmlData).find('VehicleNavCallouts > Callouts');
  $data.toArray().forEach(function (el) {
    var children = el.childNodes;
    var series = children[0].textContent;
    var text = children[1].textContent;
    var obj = {
      series: series.split('|')[0],
      text: text
    };
    callOut.push(obj);
  });

  return callOut;
}

var VehiclesPlugin = Navigation.Plugin.extend({
  initialize: function (nav, navOpt) {
    this.options = $.extend({}, VehiclesPlugin.defaults, navOpt.vehicles);
  },

  onModelLoaded: function (model) {
    var self = this;
    var nav = this.getNavigation();
    var compareSource = '';

    nav.walk(function (link, path) {
      // Checking for the link with the key vehicles
      if (link.key === 'vehicles' || link.key === 'mobile-vehicles') {
        // Determine what mode we are in
        var region = nav.getPathRegion(path);
        var renderMode;
        compareSource = link['compareSource'];

        if (region === false || region.key === 'utility') {
          // Unknown or Utility region is rendered as a standard link
          // do nothing
          return;
        }

        if (self.options.carouselRegions.indexOf(region.key) >= 0) {
          renderMode = CarouselMode;
        } else {
          renderMode = ContainerMode;
        }

        if (renderMode) {
          link = $.extend({}, link);
          link.type = 'vehicles';
          link['data-nav-plugin'] = 'vehicles';
          link['data-rendermode'] = renderMode;
          link['data-disabledseries'] = JSON.stringify(BATSiteConfig.disabledVehicles || []);
          link['data-path'] = nav.pathToString(path, link);
          return link;
        }
      }
    });

    // This is the only spot we have access to wether the TDA has chosen 'local' or 'default'
    // for their comapre vehicle association
    PageCache.set('series.compare.association.location', compareSource === 'local' ? 'local' : 'global');
  },

  onRendered: function () {
    // Based on what we found above, trigger some js
    var opt = this.options;
    var nav = this.getNavigation();
    // BAT-4777 keyboard navigation for "SEE OFFERS” and “COMPARE” links
    nav.$el.on('keydown', '#nav-vehicles', this.onMenuKeyDown.bind(this, nav));
    nav.$el.on('navigationcollapsed', '.site-nav-link-type-vehicles', this.onNavigationCollapsed.bind(this, nav));

    var compareCacheId = 'series.compare.urlMap';

    var dcrPath = __vehicleNavCalloutsDcr + '.xml';
    if (__lang === 'es') {
      dcrPath = __vehicleNavCalloutsDcr + '_es.xml';
    }
    lscs.dcr().fetch({ path: dcrPath }).then(__parseVehicleNavCalloutsDcr);

    PageCache
      .await(compareCacheId)
      .then(function (comp) {
        __compareList = __convertObjToList(comp);

        PageCache
          .await('series.byCategory.merged.hybrids')
          .then(function (categories) {
            // We have the categorized series data, fill in the placeholders
            $('[data-nav-plugin="vehicles"]', nav.$el).each(function () {
              var $el = $(this);
              var link = nav.linkByPathString($el.data('path'));
              var renderMode = $el.data('rendermode');
              var disabledSeries = $el.data('disabledseries');

              // Build the link list for the container based vehicle menu
              var categoryLinks = Object
                .keys(categories)
                .filter(function (catId) {
                  if (opt.disabledCategories && opt.disabledCategories.length) {
                    return opt.disabledCategories.indexOf(catId) < 0;
                  }
                  return true;
                }).map(function (catId) {
                  var cat = categories[catId];
                  return {
                    id: 'category-' + cat.code,
                    type: 'container',
                    title: cat.name,
                    'data-relative-content-section': link.title,
                    links: cat.series
                      .filter(function (series) {
                        return disabledSeries.indexOf(series.series_code) < 0;
                      }).map(function (series, idx) {
                        var dataLayer = $.extend({}, blocks.seriesBlock(series), { content_position_element: idx + '' });
                        return {
                          id: 'series-' + series.series_code,
                          type: 'series',
                          useBookmarkLinks: link.useBookmarkLinks,
                          series: $.extend({}, series, { series_display_name: __formatDisplayName(series.series_display_name) }),
                          dataLayer: JSON.stringify(dataLayer),
                          assetUrlPrefix: opt.assetUrlPrefix,
                          callOutLabel: callouts.getVehicleCallout(series.series_code, callOut),
                          'data-relative-content-section': link.title + '/' + cat.name,
                          showCompareLink: link.compareSource !== 'off' && __checkHasCompare(series.series_code)
                        };
                      }),
                  };
                });

              if (CarouselMode === renderMode) {
                $el = $(nav.renderInContext(__tmplCarousel, { link: link, categoryLinks: categoryLinks })).replaceAll($el);
                $el.each(function () {
                  var $this = $(this);
                  var needsReload = true;
                  var $nextSlide = $this.find('.arrow-control.next');
                  var $prevSlide = $this.find('.arrow-control.prev');
                  var slider;
                  var isPrevNextTabEnter = false;
                  var updateActive = function (idx, nSlides) {
                    $prevSlide[idx > 0 ? 'addClass' : 'removeClass']('active');
                    $nextSlide[idx < nSlides - 1 ? 'addClass' : 'removeClass']('active');
                    // BAT-4775 Keyboard Controls - Enable User to reach arrows < > (adding 2 'a' elements behind bxSlider controls)
                    if (slider) {
                      $('#site-nav-vehicles-previuos-tab a').attr('tabindex', idx > 0 ? 0 : -1);
                      $('#site-nav-vehicles-next-tab a').attr('tabindex', idx < nSlides - 1 ? 0 : -1);
                      $(slider).find('.site-nav-vehicles-slide a').attr('tabindex', -1);
                      $(slider).find('.site-nav-vehicles-slide span').attr('tabindex', -1);
                      $(slider.$slider.slick('slickCurrentSlide')).find('a').removeAttr('tabindex');
                      $(slider.$slider.slick('slickCurrentSlide')).find('span').removeAttr('tabindex');
                      if (isPrevNextTabEnter && $(slider.$slider.slick('slickCurrentSlide')).find('a').length > 0) {
                        setTimeout(function () {
                          $(slider.$slider.slick('slickCurrentSlide')).find('a')[0].focus();
                        }, 500);
                      }
                    }
                    isPrevNextTabEnter = false;

                    var $pagerLink = $('.site-nav-vehicles-pager').find("[data-slide-index='" + idx + "']");
                    $('.site-nav-vehicles-pager a').removeClass('active');
                    $pagerLink.addClass('active');
                  };
                  var onPrevSlideKeyUp = function (event) {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                      event.preventDefault();
                      isPrevNextTabEnter = true;
                      slider.$slider.slick('slickPrev');
                    }
                  };
                  var onNextSlideKeyUp = function (event) {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                      event.preventDefault();
                      isPrevNextTabEnter = true;
                      slider.$slider.slick('slickNext');
                    }
                  };
                  slider = new Slicker({
                    $slider: $('.site-nav-vehicles-carousel-container'),
                    slickOptions: {
                      slide: '.site-nav-vehicles-slide',
                      infinite: false,
                      useCSS: true,
                      dots: false,
                      arrows: false,
                      slidesToShow: 1,
                      swipe: false,
                      adaptiveHeight: true,
                      initFunction: function () {
                        setTimeout(function () {
                          // BAT-4775 Keyboard Controls - Enable User to reach arrows < > (adding 2 'a' elements behind bxSlider controls)
                          $('.site-nav-vehicles-wrap div.bx-carousel-controls div').css({ 'z-index': 10 });
                          if (!($('#site-nav-vehicles-previuos-tab').length > 0)) {
                            $('.site-nav-vehicles-wrap div.site-nav-vehicles-carousel-container').before('<div class="bx-carousel-controls" id="site-nav-vehicles-previuos-tab"><a data-linktext="previous" aria-label="previous slide" class="arrow-control prev datalayer-link" tabindex="0"><i class="icon icon-arrow-thin-left"></i></a></div>');
                            $('#site-nav-vehicles-previuos-tab').on('keyup', onPrevSlideKeyUp.bind(this));
                          }
                          if (!($('#site-nav-vehicles-next-tab').length > 0)) {
                            $('.site-nav-vehicles-wrap div.site-nav-vehicles-carousel-container').after('<div class="bx-carousel-controls" id="site-nav-vehicles-next-tab"><a data-linktext="next" aria-label="next slide" class="arrow-control next datalayer-link" tabindex="0"><i class="icon icon-arrow-thin-right"></i></a></div>');
                            $('#site-nav-vehicles-next-tab').on('keyup', onNextSlideKeyUp.bind(this));
                          }

                          // trigger an event on navEL
                          var slideCount = $('.site-nav-vehicles-carousel-container .slick-slide').length;
                          updateActive(0, slideCount);
                        }, 0);
                      },
                      beforeFunction: function (e, slick, currentSlide, nextSlide) {
                        var $slideEl = $(slick.$slides[nextSlide]);
                        updateActive(nextSlide, slick.slideCount);
                        $(nav).trigger('loadimages', { $scope: $slideEl });
                      }
                    }
                  });
                  $this.find('.arrow-control.next').on('click', function (e) {
                    e.preventDefault();
                    slider.$slider.slick('slickNext');
                  });
                  $this.find('.arrow-control.prev').on('click', function (e) {
                    e.preventDefault();
                    slider.$slider.slick('slickPrev');
                  });

                  $this.on('navigationexpanded', function () {
                    if (needsReload) {
                      slider.$slider.slick('refresh');
                      $(nav).trigger('loadimages', { $scope: slider.$slider.slick('slickCurrentSlide') });
                      needsReload = false;
                    }
                  });
                });

                $('.site-nav-vehicles-pager a').click(function (e) {
                  e.preventDefault();
                  var $pagerLink = $(this);
                  var slIdx = $pagerLink.data('slide-index');
                  var slider = $('.site-nav-vehicles-carousel-container');
                  slider.slick('slickGoTo', slIdx);
                });
              } else if (ContainerMode === renderMode) {
                $el = $(nav.renderInContext(__tmplContainer, {
                  isMobile: $el.closest('.site-nav-mobile-cta').length > 0,
                  link: link,
                  categoryLinks: categoryLinks
                })).replaceAll($el);

                categoryLinks.map(function (cat) {
                  $('[data-linkid="' + cat.id + '"]', $el).each(function () {
                    var $this = $(this);
                    $this.on('navigationexpanding', function () {
                      $(nav).trigger('loadimages', { $scope: $this });
                    });
                  });
                });
              }

              // Inject disclaimers
              // TODO: Determine a better way to do this
              $(function () {
                // BAT-3935: Have to wait until dom is fully ready otherwise disclaimer service breaks.
                disclaimers.msrpMpgDigits('li[data-linkid="' + $el.data('linkid') + '"]', true);
              });
            });

            var $expandedVehicleMenu = $('.site-nav-vehicles-container');
            $expandedVehicleMenu.each(function() {
              var labelText = $(this).find('> span > .container-button').text();
              $(this).find('> .site-nav-link-container').prepend('<li class="close-submenu">'+labelText+' <button class="site-nav-mobile-hide" tabindex="0"><i class="icon icon-close-modal using-mouse" aria-hidden="true"></i><span class="reader-hidden-text">Close Menu</span></button></li>');
              $(this).find('> .site-nav-link-container li:first-child').click(function() {
                $(this).parent('.site-nav-link-container').parent('.site-nav-link-type-container').removeClass('site-nav-link-container-expanded');
              });
              $(this).find('ul li').each(function() {
                var subMenuLabelText = $(this).find('> span > .container-button').text();
                $(this).find('> .site-nav-link-container').prepend('<li class="close-submenu">'+subMenuLabelText+' <button class="site-nav-mobile-hide" tabindex="0"><i class="icon icon-close-modal using-mouse" aria-hidden="true"></i><span class="reader-hidden-text">Close Menu</span></button></li>');
              });
              $(this).find('> .site-nav-link-container li:first-child').click(function() {
                $(this).parent('.site-nav-link-container').parent('.site-nav-link-type-container').removeClass('site-nav-link-container-expanded');
              });
            });

            $('.close-submenu .site-nav-mobile-hide, .site-nav-mobile-top-bar .site-nav-mobile-hide').click(function() {
              window.scrollTo(0, 0);
              $(this).parents('body').removeClass('no-overflow');
              $(this).parents('body').find('.main-mobile-nav-wrapper .site-nav-link-container-expanded').removeClass('site-nav-link-container-expanded');
              $(this).parents('.main-mobile-nav-wrapper').removeClass('get-in-front');
            });

            $('.main-mobile-nav-wrapper .site-nav-expanded-menu-content > .site-nav-link-container > li > ul > .close-submenu').click(function() {
              $(this).parents('.main-mobile-nav-wrapper').removeClass('get-in-front');
            });

            var $expandedMobTypeContainer = $('.main-mobile-nav-wrapper .site-nav-expanded-menu-content .site-nav-link-container > li.site-nav-link-type-container > span');
            $expandedMobTypeContainer.click(function() {
              $expandedMobTypeContainer.parents('.main-mobile-nav-wrapper').addClass('get-in-front');
            });

          });
      });
  },
  // BAT-4777 keyboard navigation for "SEE OFFERS” and “COMPARE” links
  onMenuKeyDown: function (nav, event) {
    if (event && nav && (event.keyCode === 13 || event.keyCode === 32)) {
      if (!$(event.target).is(nav.__selContainerExpanded)) {
        $('.site-nav-link-type-vehicles').addClass('keyboard-expanded');
      }
    }
  },

  onNavigationCollapsed: function (nav, event) {
    if (event && nav) {
      $('.site-nav-link-type-vehicles').removeClass('keyboard-expanded');
    }
  }
});

VehiclesPlugin.defaults = {
  assetUrlPrefix: '',
  disabledCategories: ['cars'],
  carouselRegions: ['primary'],
};

Navigation.registerPlugin(VehiclesPlugin);

Navigation.registerLinkTypeRenderer('vehicles', function (context, opt) {
  return __tmplLoader(context, opt);
});

Navigation.registerLinkTypeRenderer('series', txtSeries);
